import { RootState } from '..';

import { CustomerListDataModel } from '@config/api/customer/interface';

export function getCustomerListData(state: RootState): CustomerListDataModel {
  return state.customerReducer.customerList;
}
